import { useMemo } from 'react';

import {
  customerCrmRoutes,
  sysAdminCrmRoutes,
} from '../../../features/rolodex/crm-management/CRMManagementRoute.model';

export function useRoutes(tenantId?: string) {
  return useMemo(() => {
    if (tenantId) {
      return {
        ...sysAdminCrmRoutes,
      };
    } else {
      return {
        ...customerCrmRoutes,
      };
    }
  }, [tenantId]);
}
